var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "form",
      staticClass: "v-drop-zone",
      class: { "is-hover": _vm.isHover },
      on: {
        drag: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
        },
        dragstart: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
        },
        dragover: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.onEnter.apply(null, arguments)
        },
        dragenter: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.onEnter.apply(null, arguments)
        },
        dragend: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.onLeave.apply(null, arguments)
        },
        dragleave: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.onLeave.apply(null, arguments)
        },
        drop: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          return _vm.onDrop.apply(null, arguments)
        },
      },
    },
    [
      _c("input", {
        ref: "file",
        attrs: { type: "file", accept: _vm.fileType.accepted },
        on: { change: _vm.onFileChange },
      }),
      _c("i", { staticClass: "el-icon-upload" }),
      _c("span", [_vm._v(_vm._s(_vm.placeholder))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }